const categoryUserSitePublisherDevelopment = [
  {
    id: 6,
    user_id: 5,
    name: "گروه بنری روپلاک یاسر ۱۴۰۱",
    count_position: "5",
    start_date: "2022/11/04",
    end_date: "2022/11/15",
    count_day: "12",
    created_at: "2022/11/18 13:40:27",
    amount: 193665,
    sites: {
      251: {
        0: {
          title: "جایگاه های مستقل",
          price: 20500,
          positions: ["hilite-position-7", "hilite-position-6"],
        },
        9: {
          title: "صفحات محصولات",
          price: 103333,
          positions: [
            "hilite-position-68",
            "hilite-position-67",
            "hilite-position-70",
          ],
        },
        10: {
          title: "صفحات مطالب",
          price: 26500,
          positions: [
            "hilite-position-71",
            "hilite-position-72",
            "hilite-position-74",
          ],
        },
        url: "https://barikell-test.ir",
      },
      254: {
        23: {
          title: "تماس با ما",
          price: 43332,
          positions: [
            "hilite-position-136",
            "hilite-position-137",
            "hilite-position-138",
          ],
        },
        url: "https://sepehr-steel-test.ir",
      },
    },
  },
  {
    id: 5,
    user_id: 5,
    name: "گروه بنری روپلاک کاسپین ۱۴۰۱",
    start_date: "2022/11/04",
    end_date: "2022/11/16",
    count_day: "13",
    created_at: "2022/10/25 13:40:27",
    amount: 57823,
    sites: {
      254: {
        23: {
          title: "تماس با ما",
          price: 43323,
          positions: [
            "hilite-position-137",
            "hilite-position-138",
            "hilite-position-136",
          ],
        },
        25: {
          title: "صفحات مطالب",
          price: 14500,
          positions: ["hilite-position-147", "hilite-position-148"],
        },
        url: "https://sepehr-steel-test.ir",
      },
    },
  },
  {
    id: 4,
    user_id: 5,
    name: "گروه بنری روز مرد ۱۴۰۰",
    start_date: "2022/02/14",
    end_date: "2022/02/17",
    count_day: "4",
    created_at: "2022/02/12 10:48:27",
    amount: 287500,
    sites: {
      250: {
        0: {
          title: "جایگاه های مستقل",
          price: 97500,
          positions: [
            "hilite-position-2",
            "hilite-position-3",
            "hilite-position-5",
            "hilite-position-192",
          ],
        },
        4: {
          title: "صفحات محصولات",
          price: 30000,
          positions: [
            "hilite-position-42",
            "hilite-position-43",
            "hilite-position-41",
          ],
        },
        url: "https://batmatic-test.ir",
      },
      261: {
        0: {
          title: "جایگاه های مستقل",
          price: 125000,
          positions: ["hilite-position-151", "hilite-position-152"],
        },
        26: {
          title: "صفحه تماس با ما",
          price: 20000,
          positions: ["hilite-position-156"],
        },
        27: {
          title: "صفحات مطالب",
          price: 15000,
          positions: ["hilite-position-157"],
        },
        url: "https://rubitools-test.ir",
      },
    },
  },
  {
    id: 3,
    user_id: 4,
    name: "گروه بنری روز زن ۱۴۰۰",
    start_date: "2022/01/22",
    end_date: "2022/01/24",
    count_day: "3",
    created_at: "2022/01/20 19:39:23",
    amount: 310831,
    sites: {
      250: {
        2: {
          title: "درباره felotools",
          price: 46665,
          positions: [
            "hilite-position-31",
            "hilite-position-32",
            "hilite-position-34",
          ],
        },
        5: {
          title: "صفحات مطالب",
          price: 66666,
          positions: [
            "hilite-position-46",
            "hilite-position-47",
            "hilite-position-48",
          ],
        },
        url: "https://batmatic-test.ir",
      },
      251: {
        6: {
          title: "صفحه اصلی",
          price: 110000,
          positions: ["hilite-position-51", "hilite-position-52"],
        },
        8: {
          title: "تماس با ما",
          price: 87500,
          positions: [
            "hilite-position-62",
            "hilite-position-63",
            "hilite-position-64",
          ],
        },
        url: "https://barikell-test.ir",
      },
    },
  },
  {
    id: 2,
    user_id: 4,
    name: "گروه بنری عید فطر ۱۴۰۰",
    start_date: "2021/05/12",
    end_date: "2021/05/16",
    count_day: "5",
    created_at: "2021/05/10 16:47:45",
    amount: 86000,
    sites: {
      251: {
        7: {
          title: "درباره ما",
          price: 27500,
          positions: ["hilite-position-57", "hilite-position-58"],
        },
        10: {
          title: "صفحات مطالب",
          price: 18500,
          positions: ["hilite-position-71", "hilite-position-72"],
        },
        url: "https://barikell-test.ir",
      },
      261: {
        26: {
          title: "صفحه تماس با ما",
          price: 20000,
          positions: ["hilite-position-156"],
        },
        28: {
          title: "صفحه تست 2",
          price: 20000,
          positions: ["hilite-position-158"],
        },
        url: "https://rubitools-test.ir",
      },
    },
  },
  {
    id: 1,
    user_id: 4,
    name: "گروه بنری عید نوروز ۱۴۰۰",
    start_date: "2021/03/19",
    end_date: "2021/04/09",
    count_day: "22",
    created_at: "2021/03/17 11:00:16",
    amount: 334165,
    sites: {
      250: {
        1: {
          title: "صفحه اصلی",
          price: 65000,
          positions: [
            "hilite-position-27",
            "hilite-position-28",
            "hilite-position-29",
          ],
        },
        3: {
          title: "تماس با ما",
          price: 158333,
          positions: [
            "hilite-position-36",
            "hilite-position-37",
            "hilite-position-38",
            "hilite-position-39",
          ],
        },
        0: {
          title: "جایگاه های مستقل",
          price: 77500,
          positions: [
            "hilite-position-1",
            "hilite-position-2",
            "hilite-position-3",
            "hilite-position-192",
          ],
        },
        url: "https://batmatic-test.ir",
      },
      254: {
        23: {
          title: "تماس با ما",
          price: 33332,
          positions: ["hilite-position-137", "hilite-position-138"],
        },
        url: "https://sepehr-steel-test.ir",
      },
    },
  },
];

const categoryUserSitePublisherProduction = [
  {
    id: 6,
    user_id: 4,
    name: "گروه بنری روپلاک یاسر ۱۴۰۱",
    start_date: "2022/11/20",
    end_date: "2022/11/25",
    count_day: "6",
    count_position: "21",
    created_at: "2022/11/18 13:40:27",
    amount: 66000,
    sites: {
      61: {
        0: {
          title: "جایگاه های مستقل",
          price: 3500,
          positions: ["hilite-position-596"],
        },
        152: {
          title: "صفحه اصلی",
          price: 7000,
          positions: ["hilite-position-570", "hilite-position-569"],
        },
        154: {
          title: "تماس با ما",
          price: 2500,
          positions: ["hilite-position-583", "hilite-position-582"],
        },
        155: {
          title: "صفحات محصولات",
          price: 13000,
          positions: [
            "hilite-position-587",
            "hilite-position-586",
            "hilite-position-589",
          ],
        },
        url: "https://www.entes.ir",
      },
      63: {
        0: {
          title: "جایگاه های مستقل",
          price: 3500,
          positions: ["hilite-position-1722"],
        },
        91: {
          title: "صفحه اصلی",
          price: 6000,
          positions: ["hilite-position-375", "hilite-position-376"],
        },
        93: {
          title: "تماس با ما",
          price: 1000,
          positions: ["hilite-position-368"],
        },
        94: {
          title: "صفحات محصولات",
          price: 10000,
          positions: [
            "hilite-position-364",
            "hilite-position-365",
            "hilite-position-1720",
          ],
        },
        url: "https://www.ezcurra.ir",
      },
      118: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: ["hilite-position-1570"],
        },
        475: {
          title: "محصولات",
          price: 11500,
          positions: [
            "hilite-position-1562",
            "hilite-position-1563",
            "hilite-position-1565",
          ],
        },
        477: {
          title: "تماس با ما",
          price: 3500,
          positions: ["hilite-position-1568", "hilite-position-1569"],
        },
        url: "https://paatlock.ir",
      },
    },
  },
  {
    id: 5,
    user_id: 4,
    name: "گروه بنری روپلاک کاسپین ۱۴۰۱",
    start_date: "2022/10/27",
    end_date: "2022/11/01",
    count_day: "5",
    created_at: "2022/10/25 13:40:27",
    amount: 755000,
    sites: {
      20: {
        0: {
          title: "جایگاه های مستقل",
          price: 3500,
          positions: ["hilite-position-331"],
        },
        84: {
          title: "صفحه اصلی",
          price: 7000,
          positions: ["hilite-position-308", "hilite-position-310"],
        },
        85: {
          title: "تماس با ما",
          price: 2000,
          positions: ["hilite-position-311"],
        },
        url: "https://bestig.ir",
      },
      118: {
        474: {
          title: "صفحه اصلی",
          price: 8000,
          positions: ["hilite-position-1559", "hilite-position-1560"],
        },
        475: {
          title: "محصولات",
          price: 11000,
          positions: [
            "hilite-position-1562",
            "hilite-position-1563",
            "hilite-position-1564",
          ],
        },
        477: {
          title: "تماس با ما",
          price: 3500,
          positions: ["hilite-position-1568", "hilite-position-1569"],
        },
        url: "https://paatlock.ir",
      },
      143: {
        517: {
          title: "صفحه اصلی",
          price: 370000,
          positions: [
            "hilite-position-1697",
            "hilite-position-1698",
            "hilite-position-1699",
            "hilite-position-1700",
          ],
        },
        518: {
          title: "صفحات خبر",
          price: 350000,
          positions: ["hilite-position-1705", "hilite-position-1704"],
        },
        url: "https://senfnews.com",
      },
    },
  },
  {
    id: 4,
    user_id: 4,
    name: "گروه بنری روز مرد ۱۴۰۰",
    start_date: "2022/02/14",
    end_date: "2022/02/17",
    count_day: "4",
    created_at: "2022/02/12 10:48:27",
    amount: 45500,
    sites: {
      137: {
        490: {
          title: "صفحه اصلی",
          price: 14500,
          positions: [
            "hilite-position-1624",
            "hilite-position-1623",
            "hilite-position-1625",
          ],
        },
        491: {
          title: "درباره ما",
          price: 3500,
          positions: ["hilite-position-1627", "hilite-position-1626"],
        },
        493: {
          title: "محصولات",
          price: 9000,
          positions: [
            "hilite-position-1632",
            "hilite-position-1633",
            "hilite-position-1634",
          ],
        },
        url: "https://rullplug.ir",
      },
      201: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: ["hilite-position-619"],
        },
        170: {
          title: "صفحه اصلی",
          price: 11500,
          positions: [
            "hilite-position-634",
            "hilite-position-628",
            "hilite-position-635",
          ],
        },
        174: {
          title: "درباره ما",
          price: 2500,
          positions: ["hilite-position-642", "hilite-position-645"],
        },
        url: "https://www.fiorigroup.ir",
      },
    },
  },
  {
    id: 3,
    user_id: 5,
    name: "گروه بنری روز زن ۱۴۰۰",
    start_date: "2022/01/22",
    end_date: "2022/01/24",
    count_day: "3",
    created_at: "2022/01/20 19:39:23",
    amount: 67500,
    sites: {
      20: {
        0: {
          title: "جایگاه های مستقل",
          price: 3500,
          positions: ["hilite-position-331"],
        },
        84: {
          title: "صفحه اصلی",
          price: 7000,
          positions: ["hilite-position-308", "hilite-position-310"],
        },
        85: {
          title: "تماس با ما",
          price: 2000,
          positions: ["hilite-position-311"],
        },
        url: "https://bestig.ir",
      },
      84: {
        587: {
          title: "صفحه اصلی",
          price: 14500,
          positions: [
            "hilite-position-1920",
            "hilite-position-1919",
            "hilite-position-1918",
          ],
        },
        588: {
          title: "محصولات",
          price: 9000,
          positions: ["hilite-position-1922", "hilite-position-1923"],
        },
        589: {
          title: "درباره با ما",
          price: 3500,
          positions: ["hilite-position-1926", "hilite-position-1927"],
        },
        url: "https://jobs-info.ir",
      },
      237: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: ["hilite-position-1321"],
        },
        395: {
          title: "صفحه اصلی",
          price: 11000,
          positions: ["hilite-position-1323", "hilite-position-1324"],
        },
        398: {
          title: "تماس با ما",
          price: 3500,
          positions: ["hilite-position-1328", "hilite-position-1327"],
        },
        399: {
          title: "صفحات محصولات",
          price: 9000,
          positions: ["hilite-position-1331", "hilite-position-1332"],
        },
        url: "https://eimeni.ir",
      },
    },
  },
  {
    id: 2,
    user_id: 5,
    name: "گروه بنری عید فطر ۱۴۰۰",
    start_date: "2021/05/12",
    end_date: "2021/05/16",
    count_day: "5",
    created_at: "2021/05/10 16:47:45",
    amount: 40500,
    sites: {
      1: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: ["hilite-position-1268"],
        },
        379: {
          title: "صفحه اصلی",
          price: 8000,
          positions: ["hilite-position-1269", "hilite-position-1270"],
        },
        383: {
          title: "درباره با ما",
          price: 3500,
          positions: ["hilite-position-1274", "hilite-position-1273"],
        },
        url: "https://monirlock.ir",
      },
      63: {
        91: {
          title: "صفحه اصلی",
          price: 11500,
          positions: [
            "hilite-position-375",
            "hilite-position-376",
            "hilite-position-374",
          ],
        },
        92: {
          title: "درباره با ما",
          price: 2500,
          positions: ["hilite-position-372", "hilite-position-371"],
        },
        url: "https://www.ezcurra.ir",
      },
      153: {
        1: {
          title: "صفحه اصلی",
          price: 5000,
          positions: ["hilite-position-2", "hilite-position-7"],
        },
        6: {
          title: "تماس با ما",
          price: 1000,
          positions: ["hilite-position-337"],
        },
        8: {
          title: "درباره ما",
          price: 4500,
          positions: [
            "hilite-position-17",
            "hilite-position-18",
            "hilite-position-19",
          ],
        },
        url: "https://sista.ir",
      },
    },
  },
  {
    id: 1,
    user_id: 5,
    name: "گروه بنری عید نوروز ۱۴۰۰",
    start_date: "2021/03/19",
    end_date: "2021/04/09",
    count_day: "22",
    created_at: "2021/03/17 11:00:16",
    amount: 594500,
    sites: {
      84: {
        588: {
          title: "محصولات",
          price: 11500,
          positions: [
            "hilite-position-1922",
            "hilite-position-1923",
            "hilite-position-1925",
          ],
        },
        url: "https://jobs-info.ir",
      },
      143: {
        517: {
          title: "صفحه اصلی",
          price: 270000,
          positions: [
            "hilite-position-1698",
            "hilite-position-1699",
            "hilite-position-1700",
          ],
        },
        518: {
          title: "صفحات خبر",
          price: 300000,
          positions: ["hilite-position-1703", "hilite-position-1704"],
        },
        url: "https://senfnews.com",
      },
      214: {
        0: {
          title: "جایگاه های مستقل",
          price: 4500,
          positions: ["hilite-position-1054"],
        },
        307: {
          title: "صفحه اصلی",
          price: 6000,
          positions: ["hilite-position-1056", "hilite-position-1057"],
        },
        310: {
          title: "تماس با ما",
          price: 2500,
          positions: ["hilite-position-1065", "hilite-position-1064"],
        },
        url: "https://solga.ir",
      },
    },
  },
];

const getCategoryUserSitePublisher = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return categoryUserSitePublisherProduction;
  }
  return categoryUserSitePublisherDevelopment;
};

export default getCategoryUserSitePublisher();
